
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_xy00c_17",
  "refresh": "awsui_refresh_8cbea_xy00c_44",
  "disabled": "awsui_disabled_8cbea_xy00c_50",
  "selected": "awsui_selected_8cbea_xy00c_107",
  "icon": "awsui_icon_8cbea_xy00c_117",
  "with-text": "awsui_with-text_8cbea_xy00c_121",
  "with-no-text": "awsui_with-no-text_8cbea_xy00c_127",
  "root": "awsui_root_8cbea_xy00c_132",
  "segment-part": "awsui_segment-part_8cbea_xy00c_164",
  "grouped": "awsui_grouped_8cbea_xy00c_185",
  "grouped-only": "awsui_grouped-only_8cbea_xy00c_185",
  "grouped-first": "awsui_grouped-first_8cbea_xy00c_190",
  "grouped-middle": "awsui_grouped-middle_8cbea_xy00c_196",
  "grouped-last": "awsui_grouped-last_8cbea_xy00c_202",
  "select": "awsui_select_8cbea_xy00c_107",
  "segment-count-2": "awsui_segment-count-2_8cbea_xy00c_227",
  "segment-count-3": "awsui_segment-count-3_8cbea_xy00c_231",
  "segment-count-4": "awsui_segment-count-4_8cbea_xy00c_235",
  "segment-count-5": "awsui_segment-count-5_8cbea_xy00c_239",
  "segment-count-6": "awsui_segment-count-6_8cbea_xy00c_243",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_xy00c_247"
};
  